<template>
  <el-dialog top="30vh" title="" :visible.sync="isConfirmDialogShow" class="first-gift-dialog" :close-on-click-modal="true">
    <div class="confirm-dialog">
      <div class="header">温馨提示</div>
      <div class="content">
        <div v-for="(item, index) in content" :key="index">{{ item }}</div>
      </div>
      <div class="footer">
        <div class="btn" @click="isConfirmDialogShow = false">取消</div>
        <div class="btn btn1" @click="confirm">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["content"],
  data() {
    return {
      isConfirmDialogShow: false,
    };
  },
  methods: {
    open() {
      this.isConfirmDialogShow = true;
    },
    confirm() {
      this.$emit("confirmDialog", this.content);
      this.isConfirmDialogShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    width: 2.8rem !important;
    height: 0;
    border-radius: 0.1rem;
  }
}
.confirm-dialog {
  background: #ffffff;
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  padding: 0.24rem 0;
  .header {
    font-size: 0.16rem;
    margin-top: 0.24rem;
  }
  .content {
    margin: 0.2rem 0 0.3rem;
    line-height: 0.2rem;
    text-align: center;
  }
  .footer {
    display: flex;
    gap: 0.16rem;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      border: 1px solid #02a8a2;
      border-radius: 0.34rem;
      color: #02a8a2;
      line-height: 0.34rem;
      text-align: center;
      cursor: pointer;
    }
    .btn1 {
      background: #02a8a2;
      color: #ffffff;
    }
  }
}
</style>
